var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lm-banner"},[_c('div',{staticClass:"center"},[_c('div',{staticClass:"banner-overlay1"},[_c('span',{staticClass:"title"},[_vm._v("加速企业大模型  AI 应用的落地")]),_vm._v(" "),_c('p',[_vm._v("端到端的 LLMOps：模型的微调、提示")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21cdc7b8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/fastclass-loader!./src/page/h5/lm-banner.vue
// module id = null
// module chunks = 